import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';
import { errorMessage, successMessage } from '@api/messages';
import { deleteUpload } from '../api';
import { UploadToDelete } from '../dto/UploadToDelete';

function useDeleteUpload(triggerUploadsTableRefresh: (uploadsTableRefresh: boolean) => void) {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const { mutate } = useMutation(
    (uploadToDelete: UploadToDelete) => deleteUpload(uploadToDelete.id),
    {
      onSuccess: (_, uploadToDelete) => {
        queryClient.invalidateQueries('getUploadById');
        triggerUploadsTableRefresh(true);
        successMessage({
          title: t('success.upload.delete', {
            uploadName: `${uploadToDelete.name.substring(0, 23)}...`,
          }),
          message: null,
        });
      },
      onError: (error, uploadToDelete) => {
        errorMessage({
          title: t('error.upload.delete', {
            uploadName: `${uploadToDelete.name.substring(0, 23)}...`,
          }),
          message: null,
          error,
        });
      },
    }
  );
  return mutate;
}

export default useDeleteUpload;
